/**
 * context
 *  config 中处理的数据类型
 *
 *  currentLanguage,
 *
 *  全局相关的数据
 *
 * Created by Samuel on 2022/5/16
 */
import { createContext } from 'react';

export const ConfigContext = createContext({});
